import { Box, Avatar, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleUploadIcon } from 'Images';
import { isDesktop } from 'react-device-detect';

export interface IAddUploadButton {
  onClick: () => void;
  formName: string;
}

export const UploadMoreInvoiceBtn = ({
  onClick,
  formName,
}: IAddUploadButton) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  return (
    <Box
      role='button'
      sx={{
        width: '100%',
        padding: '14px 20px',
        display: 'inline-flex',
        background: '#fff',
        borderRadius: isDesktop ? '16px' : '8px',
        alignItems: 'center',
        cursor: 'pointer',
        margin: '10px 0',
        border: '2px dashed',
        borderColor: 'primary.shade_200',
      }}
      onClick={onClick}
      tabIndex={0}
      onKeyUp={(e: React.KeyboardEvent) => {
        e.key === 'Enter' && onClick();
      }}
    >
      <Avatar
        alt={''}
        src={PurpleUploadIcon}
        sx={{
          width: '22px',
          height: '22px',
        }}
      />
      <Typography variant={'body5'} ml={2} tabIndex={0}>
        {dictionary.uploadAnotherInvoice} <strong>{formName}</strong>{' '}
        {dictionary.more}
      </Typography>
    </Box>
  );
};
